module.exports = __webpack_public_path__ + "static_portal/img/roman_numerals.d0697d12.jpg";